import { render, staticRenderFns } from "./Athlete.vue?vue&type=template&id=ebcfcde4&"
import script from "./Athlete.vue?vue&type=script&lang=js&"
export * from "./Athlete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/mnt/extradrive/src/pwswim.org/www/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
